export default __webpack_public_path__ + "static/media/save-list-pay-later.4d20854d.svg";